/* eslint-disable no-underscore-dangle */
const context = process.env.VUE_APP_BASE_URL;
const contextMics = process.env.VUE_APP_BASE_URL_MICS;
const contextSas = process.env.VUE_APP_BASE_URL_MICS_SSPA;

const { pathname } = window.location;

let path = '/';
if (pathname.startsWith(context) && context !== '') {
  path = context;
} else if (pathname.startsWith(contextMics)) {
  path = contextMics;
} else if (pathname.startsWith(contextSas)) {
  path = contextSas;
}
if (!path.endsWith('/')) {
  path = `${path}/`;
}

export default {
  getContext: () => {
    console.log('[vue] getting root context path', path);
    return path;
  },
};
